import React, { useState } from 'react';
import { SlidersHorizontal, LayoutGrid, List } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { MOCK_PRODUCTS } from '../context/AppContext';
import { Header } from '../components/ui/Header';
import { ProductCard } from '../components/ui/ProductCard';
export function ProductListScreen() {
  const {
    currentParams
  } = useNavigation();
  const [isGrid, setIsGrid] = useState(true);
  const categoryId = currentParams?.categoryId;
  const categoryName = currentParams?.categoryName || 'Products';
  const products = categoryId ? MOCK_PRODUCTS.filter(p => p.categoryId === categoryId) : MOCK_PRODUCTS;
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-gray-50" data-id="element-1128">
      <Header title={categoryName} data-id="element-1129" />

      <div className="bg-white px-4 py-3 flex justify-between items-center border-b border-gray-100 sticky top-[53px] z-30" data-id="element-1130">
        <span className="text-sm text-gray-500" data-id="element-1131">
          {products.length} items found
        </span>
        <div className="flex items-center gap-3" data-id="element-1132">
          <button className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-primary" data-id="element-1133">
            <SlidersHorizontal className="w-4 h-4" data-id="element-1134" /> Filter
          </button>
          <div className="w-px h-4 bg-gray-200" data-id="element-1135"></div>
          <button onClick={() => setIsGrid(!isGrid)} className="text-gray-500 hover:text-primary" data-id="element-1136">
            {isGrid ? <List className="w-5 h-5" data-id="element-1137" /> : <LayoutGrid className="w-5 h-5" data-id="element-1138" />}
          </button>
        </div>
      </div>

      <div className={`p-4 ${isGrid ? 'grid grid-cols-2 gap-4' : 'flex flex-col gap-4'}`} data-id="element-1139">
        {products.length > 0 ? products.map(product => <ProductCard key={product.id} product={product} layout={isGrid ? 'grid' : 'list'} data-id="element-1140" />) : <div className="col-span-2 py-12 text-center text-gray-500" data-id="element-1141">
            No products found in this category.
          </div>}
      </div>
    </motion.div>;
}